// extracted by mini-css-extract-plugin
module.exports = {"releaseNotesModal":"ReleaseNotesModal_releaseNotesModal__33Nht","content":"ReleaseNotesModal_content__3byxq","actionButtons":"ReleaseNotesModal_actionButtons__1_0Gg"};